import React from "react";
import "./SecondButton.css";

const SecondButton = ({ children, onClick, className = "" }) => {
  return (
    <button
      className={`second-button ${className}`.trim()}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
};

export default SecondButton;
